import React, { useEffect } from 'react';
import RegisterService from '@Services/Register';
import RegisterComponent from './Register';

function RegisterContainer(props) {
  useEffect(() => {
    const fetchData = async () => {
      const data = await RegisterService.getData();
      if (data.bulkId && data.bulkPassword) {
        // setHasAccess(true);
        Promise.resolve();
      } else {
        // history.push(paths.ACCESS_DENIED); // Redirect to an access denied page
      }
    };

    fetchData();
  }, []);
  return (
    <div>
      <RegisterComponent {...props} />
    </div>
  );
}

export default RegisterContainer;
